import { Check } from "lucide-react";
import clsx from "clsx";

const ORDER_STEPS = ["PENDING", "CONFIRMED", "PROCESSING", "SHIPPED", "DELIVERED"] as const;

export interface StatusTimelineProps {
  status: string;
  cancelled?: boolean;
}

export function StatusTimeline({ status, cancelled }: StatusTimelineProps) {
  if (cancelled || status === "CANCELLED") {
    return <p className="text-sm text-red-500 font-medium">Order cancelled</p>;
  }

  const currentIndex = ORDER_STEPS.indexOf(status as (typeof ORDER_STEPS)[number]);

  return (
    <div className="flex items-center">
      {ORDER_STEPS.map((step, i) => {
        const done = i <= currentIndex;
        const isLast = i === ORDER_STEPS.length - 1;
        return (
          <div key={step} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={clsx(
                  "h-6 w-6 rounded-full flex items-center justify-center transition-colors duration-300",
                  done ? "bg-accent text-ink" : "bg-surface border border-border text-ink-muted"
                )}
              >
                {done && <Check size={12} />}
              </div>
              <span className={clsx("text-[11px] whitespace-nowrap", done ? "text-ink" : "text-ink-muted")}>
                {step[0] + step.slice(1).toLowerCase()}
              </span>
            </div>
            {!isLast && (
              <div className={clsx("h-px flex-1 mx-1 transition-colors duration-300", i < currentIndex ? "bg-accent" : "bg-border")} />
            )}
          </div>
        );
      })}
    </div>
  );
}
